import { render } from "./AddModalTarification.vue?vue&type=template&id=3d9d7eb0&ts=true"
import script from "./AddModalTarification.vue?vue&type=script&lang=ts"
export * from "./AddModalTarification.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__